/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['./unitService'], function(UnitService) {
    'use strict';
    return new UnitService();
});



// WEBPACK FOOTER //
// ./config/unit/globalUnitService.js